import { Button } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => {
	return (
		<CssColumnGrid columns={2}>
			<Button
				design="secondary"
				res="Resource"
				resParams={["Button"]}
			/>
			<Button design="secondary">Not localized</Button>
		</CssColumnGrid>
	);
};